{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "اپ گریڈ",
    "navBilling": "بلنگ"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "آپ کا ٹیب۔ آپ کا <em>ذکر</em>۔<br />بلند تر۔",
    "subtitle": "ایک پُرسکون، خوبصورت نئے ٹیب میں — نماز کے اوقات اور AI آیت کے تدبر سے لے کر موسم اور اہم کاموں تک — ایک بامقصد دن کے لیے درکار ہر خصوصیت۔",
    "comparison_aria": "پلان کا موازنہ",
    "free": {
      "tierLabel": "موجودہ",
      "tierName": "مفت",
      "freeLabel": "ہمیشہ مفت",
      "list_aria": "مفت پلان کی خصوصیات"
    },
    "pro": {
      "list_aria": "پرو پلان کی خصوصیات",
      "tierLabel": "اپ گریڈ کریں",
      "tierName": "Pro",
      "pricePeriod": "/ ماہ",
      "priceAlt": "یا $39.99 / سال"
    },
    "freeFeatures": {
      "clockDate": "گھڑی اور تاریخ کا ڈسپلے",
      "verseOfDay": "دن کی قرآنی آیت",
      "dailyBackground": "روزانہ پس منظر کی تصویر",
      "qiblaCompass": "قبلہ کمپاس",
      "basicTasks": "بنیادی کام"
    },
    "proFeatures": {
      "weatherForecast": "5 دن کی موسمی پیش گوئی",
      "verseFavorites": "پسندیدہ آیات محفوظ کریں اور دیکھیں",
      "notesAi": "AI تجزیہ کے ساتھ نوٹس",
      "priorityTasks": "ترجیحی کاموں کا انتظام",
      "verseReflection": "AI کے ساتھ آیت پر تدبر"
    },
    "plans": {
      "monthly": {
        "label": "ماہانہ",
        "price": "$4.99",
        "period": "/ ماہ",
        "note": "ماہانہ بل"
      },
      "yearly": {
        "label": "سالانہ",
        "price": "$39.99",
        "period": "/ سال",
        "note": "دو ماہ مفت",
        "badge": "33% بچائیں"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "کسی بھی وقت منسوخ کریں۔ آپ کی رسائی بلنگ مدت کے اختتام تک جاری رہتی ہے، کوئی جزوی چارجز نہیں۔",
    "billingPeriod_aria": "بلنگ مدت",
    "cta": "محفوظ چیک آؤٹ کی طرف بڑھیں",
    "ctaLoading": "چیک آؤٹ کی طرف منتقل کیا جا رہا ہے…",
    "promoManual": "رعایت حاصل کرنے کے لیے اگلے صفحے پر کوڈ {{code}} درج کریں۔",
    "signingUpAs": "بطور {{account}} سائن اپ کر رہے ہیں",
    "trustSignals_aria": "بھروسے کے نشانات",
    "reassurance": {
      "secureCheckout": "Stripe کے ذریعے محفوظ چیک آؤٹ",
      "cancelAnytime": "کسی بھی وقت منسوخ کریں، کوئی سوال نہیں",
      "accessUntilEnd": "مدت کے اختتام تک رسائی"
    },
    "errors": {
      "restoreSession": "آپ کا سیشن بحال نہیں ہو سکا۔ براہ کرم ایکسٹینشن سے دوبارہ کوشش کریں۔",
      "checkoutFailed": "چیک آؤٹ شروع کرنے میں ناکام۔ براہ کرم دوبارہ کوشش کریں۔"
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "غیر مقفل خصوصیات",
    "unlockedFeatures": {
      "weatherForecast": "5 دن کی موسمی پیش گوئی",
      "verseFavorites": "پسندیدہ آیات محفوظ کریں اور دیکھیں",
      "notesAi": "AI تجزیہ کے ساتھ نوٹس",
      "priorityTasks": "ترجیحی کاموں کا انتظام",
      "verseReflection": "AI کے ساتھ آیت پر تدبر"
    },
    "success": {
      "title": "Pro میں خوش آمدید",
      "desc": "آپ کی رکنیت فعال ہے۔ تمام Pro خصوصیات کے لیے ایکسٹینشن پر واپس جائیں۔",
      "viewBilling": "بلنگ کی تفصیلات دیکھیں",
      "closeTab": "یہ ٹیب بند کریں"
    },
    "cancel": {
      "title": "چیک آؤٹ منسوخ",
      "desc": "فکر کی کوئی بات نہیں — آپ کا پلان تبدیل نہیں ہوا اور آپ سے کوئی چارج نہیں لیا گیا۔ آپ جب تیار ہوں اپ گریڈ کر سکتے ہیں۔",
      "backToUpgrade": "اپ گریڈ پر واپس",
      "returnToExtension": "ایکسٹینشن پر واپس جائیں"
    }
  },
  "billing": {
    "title": "بلنگ",
    "subtitle": "اپنی رکنیت کا انتظام کریں اور ادائیگی کی تاریخ دیکھیں۔",
    "subscription_aria": "رکنیت کی حیثیت",
    "subscriptionTitle": "رکنیت",
    "loading_aria": "بلنگ معلومات لوڈ ہو رہی ہیں",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "فعال",
      "trialing": "مفت آزمائش",
      "past_due": "واجب الادا",
      "unpaid": "غیر ادا شدہ",
      "canceled": "منسوخ",
      "incomplete": "نامکمل",
      "none": "کوئی رکنیت نہیں"
    },
    "planValues": {
      "proYearly": "Pro · سالانہ",
      "proMonthly": "Pro · ماہانہ"
    },
    "warnings": {
      "paymentFailedTitle": "ادائیگی ناکام",
      "paymentFailedDesc": "آپ کی آخری ادائیگی مکمل نہیں ہوئی۔ Pro رسائی برقرار رکھنے کے لیے ”بلنگ کا انتظام“ کے ذریعے اپنا ادائیگی کا طریقہ اپ ڈیٹ کریں۔",
      "trialEndingTitle": "آزمائش جلد ختم ہو رہی ہے",
      "trialEndingToday": "آپ کی مفت آزمائش آج {{date}} کو ختم ہو رہی ہے۔ اپنی Pro خصوصیات برقرار رکھنے کے لیے ادائیگی کا طریقہ شامل کریں۔",
      "trialEndingInDays_one": "آپ کی مفت آزمائش {{count}} دن میں {{date}} کو ختم ہو رہی ہے۔ اپنی Pro خصوصیات برقرار رکھنے کے لیے ادائیگی کا طریقہ شامل کریں۔",
      "trialEndingInDays_other": "آپ کی مفت آزمائش {{count}} دنوں میں {{date}} کو ختم ہو رہی ہے۔ اپنی Pro خصوصیات برقرار رکھنے کے لیے ادائیگی کا طریقہ شامل کریں۔"
    },
    "cancellationScheduled": "منسوخی شیڈول کر دی گئی۔ آپ کو <strong>{{date}}</strong> تک مکمل Pro رسائی حاصل رہے گی۔",
    "sublabel": {
      "trialEndsToday": "آزمائش آج ختم ہوتی ہے",
      "trialDaysRemaining_one": "آزمائش میں {{count}} دن باقی",
      "trialDaysRemaining_other": "آزمائش میں {{count}} دن باقی",
      "renews": "تجدید {{date}}",
      "accessUntil": "{{date}} تک رسائی"
    },
    "kv": {
      "status": "حیثیت",
      "nextRenewal": "اگلی تجدید",
      "trialEnds": "آزمائش ختم",
      "trialDaysLeft_one": "{{count}} دن باقی",
      "trialDaysLeft_other": "{{count}} دن باقی",
      "endsToday": "آج ختم ہوتی ہے",
      "plan": "پلان"
    },
    "upgradeNudge": {
      "title": "Pro خصوصیات غیر مقفل کریں",
      "desc": "موسم، نماز کے اوقات، AI آیت کا تدبر اور مزید — $4.99/ماہ یا $39.99/سال۔",
      "cta": "اپ گریڈ"
    },
    "actions": {
      "manageBilling": "بلنگ اور ادائیگی کا طریقہ منظم کریں",
      "cancelConfirmTitle": "اپنی رکنیت منسوخ کریں؟",
      "cancelConfirmDesc": "آپ اپنی موجودہ بلنگ مدت کے اختتام تک مکمل Pro رسائی برقرار رکھیں گے۔ کوئی جزوی رقم واپس نہیں کی جاتی۔",
      "canceling": "منسوخ کیا جا رہا ہے…",
      "yesCancel": "ہاں، منسوخ کریں",
      "keepPro": "Pro برقرار رکھیں",
      "cancelSubscription": "رکنیت منسوخ کریں"
    },
    "noSubscription": "کوئی رکنیت نہیں ملی۔",
    "paymentHistory_aria": "ادائیگی کی تاریخ",
    "paymentHistoryTitle": "ادائیگی کی تاریخ",
    "invoices_aria": "انوائسز",
    "invoiceView": "دیکھیں",
    "invoiceView_aria": "{{date}} کی انوائس دیکھیں",
    "noInvoices": "ابھی تک کوئی انوائس نہیں۔",
    "dangerZone_aria": "خطرے کا زون",
    "dangerZoneTitle": "خطرے کا زون",
    "deleteAccountTitle": "اکاؤنٹ حذف کریں",
    "deleteAccountDesc": "اپنا اکاؤنٹ اور تمام متعلقہ ڈیٹا — کام، نوٹس، پسندیدہ، اور بلنگ کی تاریخ — مستقل طور پر حذف کریں۔ یہ عمل واپس نہیں ہو سکتا۔",
    "deleteAccountBtn": "اکاؤنٹ حذف کریں",
    "deleteConfirm": {
      "warning": "یہ فوری اور مستقل طور پر:",
      "list": {
        "deleteContent": "آپ کے تمام کام، نوٹس، اور پسندیدہ آیات حذف کر دے گا",
        "cancelSubscription": "کسی بھی فعال رکنیت کو منسوخ کر دے گا (غیر استعمال شدہ وقت کی واپسی نہیں)",
        "removeAccount": "ہمارے ڈیٹابیس سے آپ کا اکاؤنٹ ہٹا دے گا",
        "signOut": "آپ کو تمام آلات سے سائن آؤٹ کر دے گا"
      },
      "typeToConfirm": "تصدیق کے لیے <strong>DELETE</strong> ٹائپ کریں",
      "inputPlaceholder": "DELETE",
      "deleting": "حذف کیا جا رہا ہے…",
      "confirmBtn": "میرا اکاؤنٹ مستقل طور پر حذف کریں",
      "cancelBtn": "منسوخ کریں"
    },
    "errors": {
      "loadFailed": "بلنگ معلومات لوڈ کرنے میں ناکام۔",
      "cancelFailed": "رکنیت منسوخ کرنے میں ناکام۔",
      "deleteFailed": "اکاؤنٹ حذف کرنے میں ناکام۔ براہ کرم دوبارہ کوشش کریں یا سپورٹ سے رابطہ کریں۔",
      "portalFailed": "بلنگ پورٹل کھولنے میں ناکام۔"
    }
  },
  "privacy": {
    "tocLabel": "رازداری کی پالیسی",
    "toc_aria": "فہرست مضامین",
    "lastUpdated": "آخری بار اپ ڈیٹ<br />22 ستمبر، 2026",
    "sections": {
      "overview": "جائزہ",
      "informationWeCollect": "ہم کون سی معلومات جمع کرتے ہیں",
      "connectedServices": "منسلک سروسز (Google، Todoist، Apple)",
      "howWeUse": "ہم آپ کی معلومات کیسے استعمال کرتے ہیں",
      "howWeShare": "ہم آپ کی معلومات کیسے شیئر کرتے ہیں",
      "dataRetention": "ڈیٹا کی برقراری",
      "yourRights": "آپ کے رازداری کے حقوق",
      "california": "کیلیفورنیا کے رہائشی (CCPA/CPRA)",
      "cookies": "کوکیز اور مقامی اسٹوریج",
      "security": "ڈیٹا کی حفاظت",
      "changes": "اس پالیسی میں تبدیلیاں",
      "contact": "ہم سے رابطہ کریں"
    },
    "headings": {
      "informationWeCollect": "ہم کون سی معلومات جمع کرتے ہیں",
      "connectedServices": "منسلک سروسز (Google، Todoist، Apple)",
      "howWeUse": "ہم آپ کی معلومات کیسے استعمال کرتے ہیں",
      "howWeShare": "ہم آپ کی معلومات کیسے شیئر کرتے ہیں",
      "dataRetention": "ڈیٹا کی برقراری",
      "yourRights": "آپ کے رازداری کے حقوق",
      "california": "کیلیفورنیا کے رہائشی (CCPA / CPRA)",
      "cookies": "کوکیز اور مقامی اسٹوریج",
      "security": "ڈیٹا کی حفاظت",
      "changes": "اس پالیسی میں تبدیلیاں",
      "contact": "ہم سے رابطہ کریں"
    }
  },
  "deleteAccount": {
    "intro": "اکاؤنٹ حذف کرنے سے یہ مستقل طور پر حذف ہو جائیں گے:",
    "list": {
      "account": "آپ کا اکاؤنٹ اور پروفائل",
      "tasks": "تمام کام",
      "notes": "تمام نوٹس",
      "verses": "محفوظ آیات",
      "billing": "سبسکرپشن کا ریکارڈ"
    },
    "irreversible": "یہ عمل واپس نہیں ہو سکتا۔",
    "appleNotice": "اکاؤنٹ حذف کرنے سے App Store کے ذریعے خریدی گئی سبسکرپشن منسوخ نہیں ہوتی۔ براہ کرم اسے ترتیبات ← Apple ID ← Subscriptions میں جا کر بھی منسوخ کریں۔",
    "manageSubscription": "سبسکرپشن منظم کریں",
    "continueBtn": "حذف جاری رکھیں",
    "keepBtn": "میرا اکاؤنٹ رکھیں",
    "confirmTitle": "اپنا اکاؤنٹ حذف کریں؟",
    "confirmDesc": "آپ کا اکاؤنٹ اور اس کا تمام ڈیٹا مستقل طور پر حذف کر دیا جائے گا۔ یہ عمل واپس نہیں ہو سکتا۔",
    "confirmBtn": "میرا اکاؤنٹ مستقل طور پر حذف کریں",
    "deleting": "حذف کیا جا رہا ہے…",
    "error": "ہم آپ کا اکاؤنٹ حذف نہیں کر سکے۔ براہ کرم اپنا کنکشن چیک کر کے دوبارہ کوشش کریں۔"
  }
}
